module.exports = __webpack_public_path__ + "static/media/img_54.20a3415c.png";